/* eslint-disable import/prefer-default-export */
import CashFlowTablesEnum from '@/views/cashFlowGroupers/mainGrouper/enums/CashFlowTablesEnum';
import IPredictedFlowGrouperList from '../../interfaces/groupers/IPredictedFlowGrouperList';
import { setApproveButtonShow, setDisregardValueButtonShow } from './ComponentClassStatesService';
import IDisregardValueChangedGroup from '../../interfaces/actions/IDisregardValueChangedGroup';

export const disregardedValuesData: IDisregardValueChangedGroup[] = [];

export const setDisregardTotalsByGroupRecursively = (
  identifier: string,
  totalIndex: number,
  destructuredBankBalances: IPredictedFlowGrouperList[],
) => {
  const actualRegister = destructuredBankBalances
    .find((bankBalanceData) => bankBalanceData.identifier === identifier)!;

  if (
    actualRegister.totals[totalIndex].value !== 0
    && (
      actualRegister.level === 4
      || (actualRegister.grouperType === CashFlowTablesEnum.BANKS && actualRegister.level === 3)
    )
  ) {
    actualRegister.totals[totalIndex].disregardValue = !actualRegister
      .totals[totalIndex].disregardValue;

    setDisregardValueButtonShow(
      identifier,
      totalIndex,
      actualRegister.totals[totalIndex].disregardValue,
    );

    if (actualRegister.totals[totalIndex].disregardValue) {
      actualRegister.totals[totalIndex].isReleased = false;

      setApproveButtonShow(
        identifier,
        totalIndex,
        false,
      );
    }

    disregardedValuesData.push({
      keyId: actualRegister.itemData!.keyId,
      date: actualRegister.totals[totalIndex].date!,
      disregardValue: actualRegister.totals[totalIndex].disregardValue,
    });
  }

  const childsFromActualIdentifier = destructuredBankBalances
    .filter((bankBalanceData) => bankBalanceData.parentIdentifier === identifier);

  for (let i = 0; i < childsFromActualIdentifier.length; i += 1) {
    const actualChild = childsFromActualIdentifier[i];

    setDisregardTotalsByGroupRecursively(
      actualChild.identifier,
      totalIndex,
      destructuredBankBalances,
    );
  }
};
